<template>
    <div class="main_container">
      <div class="container-fluid edit-story-wrapper" :class="selectedNodeType">
        <div class="borderEditView">
            <!-- Tools bar contains 2 divs -->
          <div class="tools-bar"
            v-if="
              this.selectedLogic.category == 'Scene' ||
              this.selectedLogic.category == 'Page'
            "
            >
          <button
            class="AddScene"
            type="button"
            @click="activePopup(0)"
            >
            <!-- @click="showComponent('')" -->

            <i class="fas fa-plus-circle"></i>
            Add assets
          </button>

            <ul class="controls-topbar">
              <li 
                title="play" 
                @click="playing ? editWEBGL() : playWEBGL()"
              >
                <span 
                  class="nav-link"
                >
                  <i class="fab fa-unity" v-if="!playing"></i>
                  <i class="fa fa-stop" v-else></i>
                </span>
              </li>
              <li id="unity-reload-button" title="reload" @click="editWEBGL()">
                <span class="nav-link">
                  <i class="fas fa-sync"></i>
                </span>
              </li>
              <li title="undo" @click="undo">
                <span 
                  class="nav-link"
                >
                  <!-- Undo -->
                  <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M15.8543 11.885C15.9192 10.8679 15.7753 9.84816 15.4313 8.8887C15.0873 7.92925 14.5507 7.05033 13.8543 6.30604C12.3132 4.81847 10.2512 3.99295 8.10933 4.00604C8.07325 4.004 8.0393 3.98828 8.0144 3.96208C7.9895 3.93589 7.97553 3.90118 7.97533 3.86504V0.955038C7.97534 0.929612 7.96852 0.90465 7.95559 0.882759C7.94266 0.860868 7.92408 0.842851 7.90181 0.83059C7.87954 0.818329 7.85438 0.812273 7.82896 0.813056C7.80355 0.813838 7.77881 0.82143 7.75733 0.835038L0.167334 5.83504C0.147733 5.84786 0.131634 5.86536 0.120492 5.88596C0.10935 5.90656 0.103516 5.92962 0.103516 5.95304C0.103516 5.97646 0.10935 5.99951 0.120492 6.02011C0.131634 6.04072 0.147733 6.05822 0.167334 6.07104L7.75733 11.071C7.77867 11.0854 7.80354 11.0935 7.82921 11.0947C7.85489 11.0958 7.88038 11.0899 7.9029 11.0775C7.92541 11.0651 7.94408 11.0467 7.95686 11.0244C7.96963 11.0021 7.97603 10.9767 7.97533 10.951V8.08204C7.97531 8.06292 7.97918 8.04399 7.9867 8.02641C7.99421 8.00883 8.00523 7.99297 8.01908 7.97978C8.03292 7.96659 8.0493 7.95635 8.06722 7.94969C8.08515 7.94303 8.10424 7.94009 8.12333 7.94104C9.30663 7.96552 10.4709 8.24379 11.5373 8.75704C12.8805 9.4302 14.0254 10.4413 14.8593 11.691C15.1587 12.1299 15.4108 12.5991 15.6113 13.091C15.6226 13.1202 15.6423 13.1453 15.668 13.1632C15.6936 13.181 15.7241 13.1907 15.7553 13.191H15.8543C15.8543 12.775 15.8543 12.248 15.8543 11.885Z" fill="#fff"/>
                  </svg>
                </span>
              </li>
              <li title="redo" @click="redo">
                <span 
                  class="nav-link"
                >
                  <!-- Redo -->
                  <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0.110854 11.885C0.0459718 10.8679 0.189937 9.84816 0.533891 8.8887C0.877844 7.92925 1.41451 7.05033 2.11085 6.30604C3.65099 4.81785 5.71223 3.99128 7.85385 4.00304C7.88994 4.001 7.92389 3.98528 7.94879 3.95909C7.97369 3.93289 7.98766 3.89818 7.98785 3.86204V0.955038C7.98784 0.929612 7.99466 0.90465 8.0076 0.882759C8.02053 0.860868 8.0391 0.842851 8.06138 0.83059C8.08365 0.818329 8.10881 0.812273 8.13422 0.813056C8.15964 0.813838 8.18438 0.82143 8.20585 0.835038L15.7959 5.83504C15.8155 5.84786 15.8316 5.86536 15.8427 5.88596C15.8538 5.90656 15.8597 5.92962 15.8597 5.95304C15.8597 5.97646 15.8538 5.99951 15.8427 6.02011C15.8316 6.04072 15.8155 6.05822 15.7959 6.07104L8.20585 11.071C8.18452 11.0854 8.15965 11.0935 8.13397 11.0947C8.1083 11.0958 8.08281 11.0899 8.06029 11.0775C8.03778 11.0651 8.01911 11.0467 8.00633 11.0244C7.99355 11.0021 7.98716 10.9767 7.98785 10.951V8.08204C7.98788 8.06292 7.98401 8.04399 7.97649 8.02641C7.96897 8.00883 7.95796 7.99297 7.94411 7.97978C7.93027 7.96659 7.91389 7.95635 7.89596 7.94969C7.87804 7.94303 7.85895 7.94009 7.83985 7.94104C6.65656 7.96552 5.49232 8.24379 4.42585 8.75704C3.08195 9.42992 1.93638 10.4411 1.10185 11.691C0.803881 12.13 0.553155 12.5993 0.353854 13.091C0.342634 13.1202 0.322907 13.1453 0.29723 13.1632C0.271554 13.181 0.241113 13.1907 0.209854 13.191H0.109854C0.107854 12.775 0.110854 12.248 0.110854 11.885Z" fill="#fff"/>
                  </svg>
                </span>
              </li>
              <li title="delete" @click="deleteNode">
                <span 
                  class="nav-link"
                >
                <!-- delete -->
                  <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2.07961 15.911C2.08172 16.4327 2.28998 16.9325 2.659 17.3013C3.02802 17.6701 3.52787 17.8782 4.04961 17.88H11.9496C12.4719 17.8789 12.9725 17.6713 13.3422 17.3024C13.7118 16.9334 13.9205 16.4332 13.9226 15.911V4.55999H2.07961V15.911ZM15.3996 1.6H11.6996L10.4606 0.119995H5.53861L4.29961 1.6H0.599609V3.08H15.3996V1.6Z" fill="#fff"/>
                        </svg>
                </span>
              </li>
              
              <!-- <router-link :to="{ name: 'simulation' }">
                <span title="simulation"
                  class="nav-link"
                > -->
                <!-- play sa -->
                  <!-- <i class="fab fa-unity fa-xl"></i>
                </span>
              </router-link> -->
              
              <li title="upload" @click="uploadJSON">
                  <span 
                    class="nav-link"
                  >
                  <!-- upload -->
                    <i class="fas fa-cloud-upload-alt fa-xl"></i>
                </span>
              </li>
              <li title="save" @click="save">
                  <span 
                    class="nav-link"
                  >
                  <!-- save -->
                    <i class="fas fa-save fa-xl"></i>
                  </span>
              </li>
              
            </ul>
            <!-- tools on right -->
            <ul class="tools controls-topbar ">
              <li class="col-4 dropdown">
                  <select class="custom-select" v-model="layout_type">
                    <option value="default">Default</option>
                    <!-- <option value="default2">Default2</option> -->
                    <!-- <option value="horizontal">Horizontal</option> -->
                    <!-- <option value="vertical">Vertical</option> -->
                  </select>
              </li>
              <!-- <a title="Search" href="#" class="search-button nbar_button"></a> -->
              <li
                title="Toggle Logic"
                @click="togglePanel('logic')"
              >
                <i class="fas fa-stopwatch fa-lg"></i>
              </li>
              <li
                title="Toggle Preview"
                @click="togglePanel('preview')"
              >
                <i class="fas fa-video fa-lg"></i>
              </li>
              <li
                title="Toggle Inspector"
                @click="togglePanel('inspector')"
              >
                <i class="fas fa-cogs fa-lg"></i>
              </li>
            </ul>

          </div>

            <div class="panel-wrapper">
            <div class="panel-wrapper">
                <div
                  v-if="isPanelOpen.logic"
                  class="col"
                  id="logic-wrapper"
                  >
                  <div id="logic" class="card">
                    <div class="card-action-buttons">
                      <button
                        class="btn btn-outline-primary btn-sm"
                        @click="expandPanel('logic')"
                      >
                        <i class="fas fa-expand-arrows-alt"></i>
                      </button>
                      <button
                        class="btn btn-outline-warning btn-sm"
                        @click="closePanel('logic')"
                      >
                        <i class="fa fa-times"></i>
                      </button>
                    </div>
                    <logicComponent
                      v-if="componentType == 'Logic'"
                    ></logicComponent>
                    <timelineComponent v-else @openComponent="openComponent">
                    </timelineComponent>
                  </div>
                </div>
                <div id="preview"
                  v-if="isPanelOpen.preview"
                  class="col"
                  >
                  <div class="card premDiv">
                    <div class="card-action-buttons">
                      <button
                        class="btn btn-outline-primary btn-sm"
                        @click="expandPanel('preview')"
                      >
                        <i class="fas fa-expand-arrows-alt"></i>
                      </button>
                      <button
                        class="btn btn-outline-warning btn-sm"
                        @click="closePanel('preview')"
                      >
                        <i class="fa fa-times"></i>
                      </button>
                    </div>
                    <div class="card-header">
                      <div
                        class="d-flex justify-content-between align-items-center"
                      >
                        <span
                          ><i class="fas fa-video"></i>
                          Preview</span
                        >
                      </div>
                    </div>
                    <div class="card-body p-0 position-relative" ref="preview">
                      <previewComponent
                        :height="height"
                        :width="width"
                        :showShadow="showShadow"
                        :showSkeleton="showSkeleton"
                        :selectedAnimation="selectedAnimation"
                        :selectedFbxModel="selectedFbxModel"
                      /> 
                    </div>
                  </div>
                </div>
                </div>
              <div v-if="isPanelOpen.inspector" id="inspector" class="col inspector-wrap">
                <div class="card">
                  <div class="card-action-buttons">
                    <button
                        class="btn btn-outline-primary btn-sm"
                        @click="expandPanel('inspector')"
                      >
                        <i class="fas fa-expand-arrows-alt"></i>
                    </button>
                    <button
                      class="btn btn-outline-warning btn-sm"
                      @click="closePanel('inspector')"
                    >
                      <i class="fa fa-times"></i>
                    </button>
                  </div>
                  <inspectorComponent
                    :showShadow="showShadow"
                    :showSkeleton="showSkeleton"
                    :showComponentType="openComponentType"
                    @showShadowChange="showShadowChange"
                    @showSkeletonChange="showSkeletonChange"
                    @showSelectedAnimation="showSelectedAnimation"
                    @showSelectedModel="showSelectedModel"
                  />
                </div>
              </div>
            </div>
        </div>
        </div>
      </div>
</template>
<script>
import StoryViewHeader from "../components/v2/story-edit-view/header";
import logicComponent from "../components/v2/story-edit-view/logic";
import previewComponent from "../components/v2/story-edit-view/newPreview";
import inspectorComponent from "../components/v2/story-edit-view/inspector";
import timelineComponent from "../components/v2/story-edit-view/timeline";
import { mapState } from "vuex";
export default {
  components: {
    StoryViewHeader,
    inspectorComponent,
    previewComponent,
    logicComponent,
    timelineComponent,
  },
  computed: {
    ...mapState(["characters"]),
  },
  data() {
    return {
      componentType: "Timeline",
      currentPopup:-1,
      isPanelOpen: {
        logic: true,
        preview: true,
        inspector: true,
      },
      isPanelExpanded: {
        logic: false,
        preview: false,
      },
      layout_type: "default",
      showShadow: true,
      height: 100,
      width: 100,
      selectedAnimation: 0,
      showSkeleton: false,
      selectedFbxModel: 0,
      openComponentType: null,
      selectedNodeType: "",
      typing: false,
      history: [],
      backup: [],
      playing: false,
    };
  },
  created() {
    //this.$on('openModalsComponent', this.showModelsComponent)
    if (!localStorage.getItem("storyId")) {
      this.$router.push("/newprofile/projects");
    }
    this.selectedLogic = JSON.parse(localStorage.getItem("selectedLogic"));
  },
  watch: {
    layout_type: function () {
      this.resizePreview();
    },
    characters(newVal,oldVal){
      this.history.push(oldVal)
    }
  },
  mounted() {
    if (this.$route.params.category) {
      this.componentType = this.$route.params.category;
    }
    this.resizePreview();
    if (this.$store.state.selectedLogic.category) {
      this.selectedNodeType =
        this.$store.state.selectedLogic.category.toLowerCase();
    }
  },
  config: {
    keyCodes: {
      z: 90,
      y: 89,
    },
  },
  methods: {
    redo() {
      if (this.backup.length != 0) {
        this.history.push(this.backup[this.backup.length - 1]);
        // this.text = this.backup[this.backup.length - 1];
        this.$store.dispatch('updateCharacters',this.backup[this.backup.length - 1])
        this.backup.pop(this.backup.length - 1);
      }
    },
    undo() {
      if (this.history.length != 0) {
        // this.text = this.history[this.history.length - 2];
        this.$store.dispatch('updateCharacters',this.history[this.history.length - 2])
        this.backup.push(this.history[this.history.length - 1]);
        this.history.pop(this.history.length - 1);
      }
    },
    deleteNode() {
       this.$root.$emit('deleteSelectedNode');
    },
    save() {
       this.$root.$emit('saveToDBADN');
    },
    playWEBGL() {
       this.$root.$emit('playScene');
       this.playing = true
    },
    editWEBGL() {
       this.$root.$emit('editScene');
       this.playing = false
    },
    UploadJSON() {
       this.$root.$emit('uploadJSON');
    },
    expandPanel(type) {
      switch (type) {
        case "logic":
          this.isPanelExpanded.logic = !this.isPanelExpanded.logic;
          break;
        case "preview":
          this.isPanelExpanded.preview = !this.isPanelExpanded.preview;
          this.resizePreview();
          break;
      }
    },
    activePopup(id){
      if (id == 0) {
        let logic = document.getElementById('logic');
          logic.style.display = 'block';
      }
      this.$store.state.sceneElementCurrentPopup = id
    },
    expandPanel(id) {
      const idX = document.getElementById(id);

      if (idX.style.position == 'fixed') {
        idX.style.position = "relative";
        idX.style.width = "auto";
        idX.style.height = 'auto';
        idX.style.left = 'auto';
        idX.style.top = 'auto';
        idX.style.zIndex = '0';
        idX.style.transform = 'none';
        document.querySelector('.edit-story-wrapper .card-body').style.height = '50vh';

        if (id == 'logic') {
        idX.style.overflow = 'overlay';
        idX.style.zIndex = '1';
        }
      } else {
        idX.style.position = 'fixed';
        idX.style.width = '90vw';
        idX.style.height = '90vh';
        idX.style.left = '52%';
        idX.style.top = '53%';
        idX.style.zIndex = '1000';
        idX.style.transform = 'translate(-50%, -50%)';
        document.querySelector('.edit-story-wrapper .card-body').style.height = '96%';

        if (id == 'logic') {
        idX.style.overflow = 'hidden';
        }
      }
    },
    closePanel(type) {
      this.isPanelExpanded.logic = false;
      this.isPanelExpanded.preview = false;

      switch (type) {
        case "logic":
          let logic = document.getElementById('logic');
          logic.style.display = 'none';
          this.resizePreview();
          break;
        case "preview":
         let preview = document.getElementById('preview');
         preview.style.display = 'none';
          break;
        case "inspector":
          this.isPanelOpen.inspector = false;
          break;
      }
    },
    togglePanel(type) {
      this.isPanelExpanded.logic = false;
      this.isPanelExpanded.preview = false;
      let logic = document.getElementById('logic');
      let preview = document.getElementById('preview');

      switch (type) {
        case "logic":
          if (logic.style.display == 'none') {
            logic.style.display = 'flex';
          } else {
            logic.style.display = 'none';
          }
          break;
        case "preview":
          if (preview.style.display == 'none') {
            preview.style.display = 'flex';
            logic.style.display.width = '50vw';
          } else {
            preview.style.display = 'none';
            logic.style.display.width = '100%';
          }
        break;
        case "inspector":
          this.isPanelOpen.inspector = !this.isPanelOpen.inspector;
          break;
      }
      this.resizePreview();
    },
    showShadowChange(data) {
      this.showShadow = data.showShadow;
    },
    showSkeletonChange(data) {
      this.showSkeleton = data.showSkeletonToggle;
    },
    showSelectedAnimation(data) {
      this.selectedAnimation = data.selectedAnimation;
    },
    showSelectedModel(data) {
      this.selectedFbxModel = data.selectedFbxModel;
    },
    openComponent(data) {
      this.openComponentType = data;
    },
    resizePreview(_this = this) {
      try {
        if (_this.$refs.hasOwnProperty("preview")) {
          _this.width = 0;
          _this.height = 0;
          setTimeout(() => {
            _this.width = _this.$refs.preview.offsetWidth;
            _this.height = _this.$refs.preview.offsetHeight;
          }, 100);
        }
      } catch (e) {}
    },
    uploadJSON() {
      let callBacks = {
        successCallback: this.showSuccessToast,
        errorCallback: this.showErrorToast,
      };
      this.$root.$emit('sendJson');
      this.$store.dispatch("uploadJSON", callBacks);
    },
    showSuccessToast() {
      this.$toast("JSON uploaded successfully", {
        timeout: 3000,
        type: "success",
        showCloseButtonOnHover: true,
      });
    },
    showErrorToast() {
      this.$toast("Uploading JSON failed", {
        timeout: 3000,
        type: "error",
        showCloseButtonOnHover: true,
      });
    },
  },
};
</script>
<style scoped lang="scss">
/* only wrote css for specific target */
@import "../../external_libs/frame.js/editor/css/dark.css";
@import "../../external_libs/frame.js/editor/css/main.css";

a {
  text-decoration: none;
}

.borderEditView {
  width: 100%;
  height: 98.5%;
  //border: 1px dashed #f634a5;
  //margin: 9px 0px 0px 1px;
  padding: 0 10px 10px 10px;
}

.edit-story-wrapper {
  padding-right: 20px;
  padding-top: 0px;
  margin: 0;
  padding: 0px 20px 0px 5px;
}

.edit-story-wrapper.scene {
    border: none;
}

.edit-story-wrapper .panel-wrapper {
    margin-right: 0;
    margin-left: 0;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    align-items: center;
    justify-content: start;
    position: relative;
    width: 100%;
}

.edit-story-wrapper .panel-wrapper .containerLP {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: start;
    width: 100%;
    margin-bottom: 10px;
}

.edit-story-wrapper .panel-wrapper>[class*="col"] {
  
  padding-right: 0;
  padding-left: 0;

  #preview {
    min-width: 510px;
  }

  #logic {
    overflow: overlay;
    resize: horizontal;
    margin-right: 10px;
    flex: 0 1 auto;
    min-width: 350px;
    max-width: 100%;
    width: 50vw;
    height: 100%;
    min-height: 50vh;
  }

  &:nth-child(2) {
    min-width: 510px;
    width: 100%;
    flex: 999;
  }

  &:nth-child(3) {
    overflow: overlay;
    resize: horizontal;
    flex: 0 1 auto;
    min-width: 50%;
    max-width: 100%;
    width: 100%;
    height: 100%;
    min-height: 50vh;
  }
}

.edit-story-wrapper .panel-wrapper .inspector-wrap .card-body {
    height: 50vh;
    background: #283046;
}

.edit-story-wrapper .panel-wrapper .inspector-wrap {
    width: 100%;
    min-width: 1555px;
    flex: 0 1 auto;
}

ol, ul, dl {
    margin: 0;
    padding: 0;
}

li::marker {
  color: transparent;
}

#unity-container, #unity-canvas {
    position: relative;
    width: 100%;
    height: 100%;
}

.tools-bar {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0;

  .tools {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    margin: 0 10px 0 0;
  }

  .AddScene {
    background-color: #293046;
    padding: 10px;
    border-radius: 5px;

    i {
      margin-right: 5px;
    }

    &:hover {
      background-color: #303030;
    }
  }
  
}



.controls-topbar {
  background-color: transparent;
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 10;
  padding: 0;

  li, a, i{
    background-color: #293046;
    border-radius: 10px;
    padding: 2px;
    margin: 0 5px;
    cursor: pointer;
    -webkit-transition: .3s all ease-in-out;
    transition: .3s all ease-in-out;
    width: 50px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    .fa-stop {
      color: green;
    }
  }
  
  li:hover, a:hover, i:hover {
    background-color: #303030;
  }
}

.fa-save {
  color: #ffffff;
}
.fa-cloud-upload-alt {
  color: #ffffff;
}
.fa-unity {
  color: #fff;
}


@media screen and (max-width: 820px) {
  .main_container {
    max-height: calc(100vh - 70px);
    overflow: hidden;
  }
  .edit-story-wrapper .panel-wrapper {
    width: 101%;
  }
  #unity-container, #unity-canvas {
    // 118px is the calcule of the tob mobile nad bottom bar width
    height: calc(100vh - 118px) !important
  }
  .edit-story-wrapper .panel-wrapper .logic-wrap {
    display: none;
  }
  .row {
    display: none;
  }
  .tools-bar {
    display: none;
  }
  .edit-story-wrapper .panel-wrapper .inspector-wrap {
    display: none;
  }
  .edit-story-wrapper .close-btn {
    display: none;
  }
  .edit-story-wrapper .card-header {
    display: none;
  }
  .edit-story-wrapper .card-action-buttons {
    display: none;
  }
  .edit-story-wrapper .panel-wrapper>[class*="col"] {
      margin-bottom: 0;
  } 
  .edit-story-wrapper {
      padding: 0;
  }
  .container, .container-fluid, .container-sm, .container-md, .container-lg, .container-xl {
      width: 100%;
      padding-right: 0;
      padding-left: 0;
  }
  .edit-story-wrapper .card-body {
    height: 100%; 
  }
  .card {
      // border: none;
      border-radius: 0.0rem;
      background: #283046;
  }
  .borderEditView {
    border: none;
    margin: 0;
    padding: 0;
  }
  .edit-story-wrapper .panel-wrapper>[class*="col"]:nth-child(2) {
    min-width: auto;
    width: 100%;
    -ms-flex: 0 1 auto;
    flex: 0 1 auto;
  }
  #logic {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/StoryEditView1.vue